import React from "react";
import { Select } from "antd";
import "./InvoiceFilterDropdown.css";

export default function InvoiceFilterDropdown({
  label,
  options = [],
  defaultValue,
  value,
  onSelect,
  onClear,
  withSearch = false,
  allowClear,
}) {
  return (
    <div className="InvoiceFilterDropdown__Container">
      {label && <label>{label}</label>}
      <Select
        className="InvoiceFilterDropdown__Select"
        popupClassName="InvoiceFilterDropdown__Select__Menu"
        showSearch={withSearch}
        options={options}
        onSelect={onSelect}
        value={value}
        defaultValue={defaultValue}
        listHeight={withSearch ? 200 : undefined}
        allowClear={allowClear}
        onClear={onClear}
        filterOption={withSearch ? (inputValue, option) => option.label?.toLowerCase().includes(inputValue?.toLowerCase()) : undefined}
      />
    </div>
  );
}
